// React
import React from 'react'
import { Provider } from 'react-redux'

// Components
import Cart from 'store/v2/react/components/cart'
import Themed from 'store/v2/react/components/Themed'

const store = window.booqableStore

export default class CartScene extends React.Component {
  static displayName = 'CartScene'

  render () {
    return (
      <Provider store={store}>
        <Themed>
          <Cart />
        </Themed>
      </Provider>
    )
  }
}
